import Select from './Select'
import MarginOptions from './MarginOptions'
import RightBarGroup from './RightBarGroup'
import Input from './Input'
import {
  ChangeEvent,
  DynamicContentType,
  GridData,
} from '@bm-js/atlascloud-shared'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

type Props = {
  content: DynamicContentType<GridData>
  setData: (e: ChangeEvent) => void
}

const GridEditor = ({ content, setData }: Props) => {
  const { tr } = useTr()

  const gridLayoutOptions = [
    {
      value: '1fr',
      name: tr(TrKey.gridEditorLayoutFullWidth),
    },
    {
      value: '2fr 1fr',
      name: '2/3 + 1/3',
    },
    {
      value: '1fr 2fr',
      name: '1/3 + 2/3',
    },
    {
      value: '1fr 1fr',
      name: '1/2 + 1/2',
    },
    {
      value: '3fr 2fr',
      name: '3/5 + 2/5',
    },
    {
      value: '2fr 3fr',
      name: '2/5 + 3/5',
    },
  ]

  return (
    <>
      <Select
        light
        label={tr(TrKey.gridEditorLayoutLabel)}
        desc={tr(TrKey.gridEditorLayoutDescription)}
        id='gridLayout'
        name='gridLayout'
        value={content.data.gridLayout}
        onChange={setData}
      >
        <option value='' disabled>
          {tr(TrKey.gridEditorLayoutPlaceholder)}
        </option>
        {gridLayoutOptions.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.name}
          </option>
        ))}
      </Select>
      {content.data.gridLayout !== '1fr' && (
        <>
          <Select
            light
            label={tr(TrKey.gridEditorGapLabel)}
            desc={tr(TrKey.gridEditorGapDescription)}
            id='gap'
            name='gap'
            value={content.data.gap}
            onChange={setData}
          >
            <option value='gap-4'>16px</option>
            <option value='gap-8'>32px</option>
            <option value='gap-16'>64px</option>
            <option value='gap-32'>128px</option>
          </Select>
          <Select
            light
            label={tr(TrKey.gridEditorDirectionLabel)}
            desc={tr(TrKey.gridEditorDirectionDescription)}
            id='mobileDirection'
            name='mobileDirection'
            value={content.data.mobileDirection}
            onChange={setData}
          >
            <option value='normal'>
              {tr(TrKey.gridEditorDirectionLeftLabel)}
            </option>
            <option value='reverse'>
              {tr(TrKey.gridEditorDirectionRightLabel)}
            </option>
          </Select>
        </>
      )}
      <RightBarGroup title='Linjer' topLine>
        <Input
          light
          type='checkbox'
          label={tr(TrKey.gridEditorTopLineLabel)}
          desc={tr(TrKey.gridEditorTopLineDescription)}
          id='topLine'
          name='topLine'
          value={content.data.topLine || false}
          onChange={setData}
        />
        <Input
          light
          type='checkbox'
          label={tr(TrKey.gridEditorBottomLineLabel)}
          desc={tr(TrKey.gridEditorBottomLineDescription)}
          id='bottomLine'
          name='bottomLine'
          value={content.data.bottomLine || false}
          onChange={setData}
        />
      </RightBarGroup>
      <Select
        light
        label={tr(TrKey.gridEditorBackgroundLabel)}
        id='backgroundColor'
        name='backgroundColor'
        value={content.data.backgroundColor}
        onChange={setData}
      >
        <option value='none'>
          {tr(TrKey.gridEditorBackgroundOptionNone)}
        </option>
        <option value='primary'>
          {tr(TrKey.gridEditorBackgroundOptionPrimary)}
        </option>
        <option value='accent'>
          {tr(TrKey.gridEditorBackgroundOptionAccent)}
        </option>
      </Select>
      <MarginOptions content={content} setData={setData} />
    </>
  )
}

export default GridEditor
